import React from 'react';

import Table, { TableProps, ControlledTableProps } from './../table';
import tableController from './table-controller';
import TableContext from './table-context';

export interface Props extends TableProps {
  tableID: string;
}
export default class ControlledTable extends React.Component<Props> {
  render() {
    const { tableID } = this.props;
    return (
      <TableContext.Consumer>
        {({
          tables,
          toggleSelect,
          onSortChange,
          onSearchChange,
          selectAll,
          deselectAll,
          setInitialConfig,
        }) => {
          const table = tables[tableID];
          const controlledProps: ControlledTableProps = {
            selectedRows: table && table.selectedRows,
            visibleColumns: table && table.visibleColumns,
            setInitialConfig: setInitialConfig(tableID),
            toggleSelect: toggleSelect(tableID),
            onSortChange: onSortChange(tableID),
            onSearchChange: onSearchChange(tableID),
            selectAll: selectAll(tableID),
            deselectAll: deselectAll(tableID),
          };

          return <Table {...{ ...this.props, ...controlledProps }} />;
        }}
      </TableContext.Consumer>
    );
  }
}
